import { render, staticRenderFns } from "./MeituanAuth.vue?vue&type=template&id=667f810e&scoped=true"
import script from "./MeituanAuth.vue?vue&type=script&lang=js"
export * from "./MeituanAuth.vue?vue&type=script&lang=js"
import style0 from "./MeituanAuth.vue?vue&type=style&index=0&id=667f810e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667f810e",
  null
  
)

export default component.exports